import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=f970c8c8&scoped=true&"
import script from "./Links.vue?vue&type=script&lang=js&"
export * from "./Links.vue?vue&type=script&lang=js&"
import style0 from "./Links.vue?vue&type=style&index=0&id=f970c8c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970c8c8",
  null
  
)

export default component.exports